'use client';
'use strict';

var React = require('react');

function useSetState(initialState) {
  const [state, _setState] = React.useState(initialState);
  const setState = React.useCallback(
    (statePartial) => _setState((current) => ({
      ...current,
      ...typeof statePartial === "function" ? statePartial(current) : statePartial
    })),
    []
  );
  return [state, setState];
}

exports.useSetState = useSetState;
//# sourceMappingURL=use-set-state.cjs.map
